module.exports = __webpack_public_path__ + "static/media/2_RoomControls_AllLights_HL.658d208e.png";